import { useState } from 'react';
import { Printer } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/pos-api';
import { goodsPrintHtml, goodsPrintModel, goodsExcelRows } from '@/lib/goods-print.mjs';
import { downloadWorkbook } from '@/lib/document-export';

export default function GoodsPrintActions({ kind, document, disabled = false, onPrintDetail, onPrintInvoice }) {
  const [paper, setPaper] = useState('A5'), [busy, setBusy] = useState(false);
  const excel = async () => {
    setBusy(true);
    try {
      const model = goodsPrintModel(kind, document);
      await downloadWorkbook({ title: `${model.title} ${model.number}`.slice(0,150), headers: model.headers, rows: goodsExcelRows(model), paper,
        notes: [...model.meta.map(([k,v]) => `${k}: ${v ?? '—'}`), ...model.totals.map(([k,v]) => `${k}: ${v ?? 'Belum lengkap'}`), ...model.notes] });
    } catch { toast.error('Ekspor gagal. Periksa koneksi dan kelengkapan data.'); }
    finally { setBusy(false); }
  };
  const print = async () => {
    const popup = window.open('', '_blank', 'width=1100,height=800');
    if (!popup) return toast.error('Izinkan popup browser untuk mencetak dokumen.');
    popup.opener = null;
    popup.document.body.textContent = 'Menyiapkan dokumen cetak…';
    setBusy(true);
    try {
      let storeName = document.store_name || '';
      if (!storeName && document.store_id) {
        try { const { data } = await api.get('/stores'); storeName = data.find(s => s.id === document.store_id)?.name || ''; } catch { /* Keep the stored branch ID if its name is unavailable. */ }
      }
      const html = goodsPrintHtml(kind, document, { paper, storeName });
      if (popup.closed) return;
      popup.document.open(); popup.document.write(html); popup.document.close(); popup.focus();
      popup.setTimeout(() => { if (!popup.closed) popup.print(); }, 150);
    } catch { popup.close(); toast.error('Dokumen belum dapat dicetak. Pastikan data transaksi sudah tersimpan dan lengkap.'); }
    finally { setBusy(false); }
  };
  return <div className="flex flex-wrap items-center gap-2" data-testid={`${kind}-print-actions`}>
    <label className="text-xs flex items-center gap-1">Kertas<select aria-label="Ukuran kertas dokumen" data-testid={`${kind}-print-paper`} value={paper} onChange={e => setPaper(e.target.value)} disabled={disabled || busy} className="h-9 rounded-md border border-ui-line bg-ui-card text-ui-text px-2"><option value="A5">A5</option><option value="A4">A4</option></select></label>
    <Button type="button" variant="outline" disabled={disabled || busy || !document?.id} onClick={print} data-testid={`${kind}-print-check`} className="gap-1"><Printer size={15} />{busy ? 'Menyiapkan…' : 'Cetak Cek Barang'}</Button>
    <Button type="button" variant="outline" disabled={disabled || busy || !document?.id} onClick={excel} data-testid={`${kind}-export-excel`}>Excel</Button>
    {onPrintDetail && <Button type="button" variant="outline" disabled={disabled || busy} onClick={() => onPrintDetail(paper)} data-testid="history-print-detail" className="gap-1"><Printer size={15} />Cetak Detail</Button>}
    {onPrintInvoice && <Button type="button" variant="outline" disabled={disabled || busy} onClick={() => onPrintInvoice(paper)} data-testid="history-print-invoice" className="gap-1"><Printer size={15} />Cetak Faktur</Button>}
  </div>;
}
